import ProjectExecutionActivationPage from "../../shared/project-execution-activation/ProjectExecutionActivationPage";

const SolarentOperatorProjectExecutionActivationPage = () => (
  <ProjectExecutionActivationPage source="SolarentOperator" />
);

export default SolarentOperatorProjectExecutionActivationPage;
